import React from 'react';
import { Button } from '../components/Button';

const base = process.env.PUBLIC_URL || '';

export function ContactSection() {
  return (
    <section id="contact" className="section-contact" aria-label="Contact">
      <div className="contact-layout">
        <img src={`${base}/images/home/damian.jpg`} alt="Damian" className="contact-image" />
        <div className="contact-info">
          <h2>Contact</h2>
          <p>Neem contact op voor een gesprek over jouw project!</p>
          <p>
            <a href="mailto:damian@dabra-development.nl">damian@dabra-development.nl</a>
          </p>
          <div className="contact-cta">
            <Button href="mailto:damian@dabra-development.nl" variant="secondary">
              Stuur een e-mail
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

